import './i18n';

import axios from 'axios';
import i18n from 'i18next';
import ReactDOM from 'react-dom/client';

import App from './App';
import { registerSyncfusionLicense } from './shared/components/SyncfusionEditor';
import { getAccessToken } from './shared/utils/getAccessToken';

registerSyncfusionLicense();

axios.defaults.baseURL = import.meta.env.VITE_HOST_API_KEY;

axios.interceptors.request.use(
  (config) => {
    if (config.headers) {
      config.headers['Accept-Language'] = i18n.language;
      if (config.params?.secure) {
        delete config.params.secure;
        const accessToken = getAccessToken();
        config.headers['Authorization'] = `Bearer ${accessToken}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(<App />);
